import { useContext } from 'react';
import { PublicPageContext } from '../context';

const usePublicPageSettings = () => {
  const publicPageSettings = useContext(PublicPageContext);

  if (!publicPageSettings)
    throw new Error('Unable to use PublicPageContext outside of PrivatePageContext Provider');

  return publicPageSettings;
};

export default usePublicPageSettings;
